<template>
  <div class="page">
    <van-row type="flex" justify="center">
      <van-col span="22">
        <div>
          <div class="sechout">
            <div class="sech-left" @click="back()">
              <van-icon name="arrow-left" color="#181616" size="20" />
            </div>
            <div class="sech-title"></div>
            <div class="sech-right"></div>
          </div>
          <div class="title">通知：本周五小区将停水！</div>
          <div class="time">发布时间：2021.08.12 18:00</div>
          <div class="content">如果我们将齐玛看做一个真实存在的艺术家，那么他真正具有艺术性的创作应当是从画作中出现蓝色的抽象图形开始的。</div>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
  export default {
    methods: {
      back() {
        this.$router.go(-1);
      },
    }
  }
</script>

<style lang="less" scoped>
  .page {
    height: 100%;
    background-color: #ffffff;
  }

  .sechout {
    padding-top: 15px;
    margin-bottom: 16px;
    height: 44px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .sech-title {
    font-size: 17px;
    font-weight: 500;
    color: #222325;
  }

  .title {
    font-size: 20px;
    font-weight: 600;
    color: #222325;
    line-height: 28px;
    margin-bottom: 12px;
  }

  .time {
    font-size: 12px;
    font-weight: 400;
    color: #B3B9BF;
    line-height: 17px;
    margin-bottom: 20px;
  }

  .content {
    font-size: 15px;
    font-weight: 400;
    color: #222325;
    line-height: 27px;
  }
</style>